import { Component, Input, SimpleChanges } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { CognitoService, IUserInfoCognito } from 'src/app/shared/services/cognito.service';
import { selectSelectedOrganization } from 'src/app/state/selectors/selectedOrganization.selectors';
import { selectUserInfo } from 'src/app/state/selectors/userInfo.selectors';

class ShowMenuOptions {
  actualizar: boolean = true;
  lcv: boolean = true;
}

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss']
})
export class SideBarComponent {
  

  @Input() selectedEmpresa: string | null | undefined = null;

  userInfo$: Observable<IUserInfoCognito> = this.store.select(selectUserInfo);
  selectedOrganization$ = this.store.select(selectSelectedOrganization);


  constructor(
    private _cognitoService: CognitoService,
    private store: Store) {
      this.selectedOrganization$.subscribe((empresa)=> {
        console.log(empresa); 
        this.selectedEmpresa = empresa;
      });
    }

  logout(){
    this._cognitoService.logout();
  }
}
